import { render, staticRenderFns } from "./layout-main-inner.vue?vue&type=template&id=05c9b30c&"
import script from "./layout-main-inner.vue?vue&type=script&lang=js&"
export * from "./layout-main-inner.vue?vue&type=script&lang=js&"
import style0 from "./layout-main-inner.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports